import api from "../../common/api";
import { Link } from 'react-router-dom';
import { useState } from "react";
import ConfirmDialog from '../ConfirmDialog';

interface Props {
    api: api;
    deleteApi: (apiKey: string) => void;
    onRegenerate: (apiKey: string) => void;
}

const ApiBlock: React.FC<Props> = ({ api, deleteApi, onRegenerate }) => {
    const [open, setOpen] = useState(false);
    const handleClose = (confirm: boolean) => {
        if(confirm) {
            deleteApi(api.api_key);
        }
        setOpen(false);
    }
    return (
        <div className="api-block">
            <div className="left-side">
                <input value={api.api_key} />
                <div className="option-icons">
                    <i className="fas fa-key" onClick={() => onRegenerate(api.api_key)} />
                    <i className="fas fa-copy" onClick={() => { navigator.clipboard.writeText(api.api_key) }} />
                    {api.folder_uid !== null && (<Link to={`/${api.folder_uid}`}><i className="fas fa-folder" /></Link>)}
                </div>
            </div>
            <ConfirmDialog 
                    title={'Are you sure you wish to delete this key?'} 
                    text={''}
                    open={open}
                    cancelButtonText={'Cancel'}
                    confirmButtonText={'Confirm'}
                    handleClose={handleClose}
            />
            <div className="cancel" onClick={() => { setOpen(true) }}>
                <i className="fas fa-times"></i>
            </div>
        </div>
    )
}

export default ApiBlock;